module.exports = __webpack_public_path__ + "media/images/village/icons-9f44956c34600be98edb10083ad3cf66.svg";